// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TblI1","colMin":"styles_colMin__NdhzS"};